$(document).find('.js_categories').each((i,el) => {
    let slides = +$(el).attr('data-count')
    let buttonNext = $(el).closest('.js_categories__container').find('.js_categories__btn-next')
    let buttonPrev = $(el).closest('.js_categories__container').find('.js_categories__btn-prev')
    let pagination = $(el).closest('.js_categories__container').find('.js_global-slider__pagination')
    new Swiper (el, {
        autoHeight: false,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            568: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1536: {
                slidesPerView: slides,
            }
        },
        navigation: {
            nextEl: buttonNext[0],
            prevEl: buttonPrev[0],
        },
        pagination: {
            el: pagination[0],
            clickable: true,
            bulletClass: 'global-slider__pagi-item',
            bulletActiveClass: 'global-slider__pagi-item_active'
        },
        modules: [SwiperModes.Navigation, SwiperModes.Pagination],
        centerInsufficientSlides: true,
    })

    // categoriesNum(slides, slidesNum,wrapper)

    // $(window).on('resize', function() {
    //     categoriesNum(slides, slidesNum, wrapper)
    // })
})

// function categoriesNum(slides, slidesNum, wrapper) {
//         wrapper.css('justify-content', 'flex-start')
//     if (window.innerWidth > 1535 && slides >= slidesNum) {
//         wrapper.css('justify-content', 'center')
//     } else if (window.innerWidth > 1023 && window.innerWidth <= 1535 && 4 >= slidesNum ) {
//         wrapper.css('justify-content', 'center')
//     } else if (window.innerWidth > 767 && window.innerWidth <= 1023 && 3 >= slidesNum ) {
//         wrapper.css('justify-content', 'center')
//     } else if (window.innerWidth > 567 && window.innerWidth <= 767 && 2 >= slidesNum ) {
//         wrapper.css('justify-content', 'center')
//     } else if (window.innerWidth < 567 && 1 >= slidesNum ) {
//         wrapper.css('justify-content', 'center')
//     }
// }